import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ZipCodeTypes } from '../Types';

const machine = Machines.onGetZipCode.machine;
export const getZipCode = (
  params: ZipCodeTypes.IZipCodeServiceRequest,
): Promise<ZipCodeTypes.IZipCodeServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { getZipCode };
